import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
import { PageHeading } from "../MediaCentre/Media.hook";

interface Corporate {
  id: number;
  title: string;
  field_content_english: {
    data: {
      adressMarkup: string; // HTML string for address section
      contactInfoHeading: string;
      map: {
        coordinates: {
          lat: string; // using string since values are quoted in JSON
          lng: string;
        };
      };
      contact: {
        image: string;
        title: string;
        description: string;
      }[];
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, unknown>;
  };
  field_content_malay: {
    data: {
      adressMarkup: string; // HTML string for address section
      contactInfoHeading: string;
      map: {
        coordinates: {
          lat: string; // using string since values are quoted in JSON
          lng: string;
        };
      };
      contact: {
        image: string;
        title: string;
        description: string;
      }[];
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, unknown>;
  };
  field_content_mandarin: {
    data: {
      adressMarkup: string; // HTML string for address section
      contactInfoHeading: string;
      map: {
        coordinates: {
          lat: string; // using string since values are quoted in JSON
          lng: string;
        };
      };
      contact: {
        image: string;
        title: string;
        description: string;
      }[];
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, unknown>;
  };
  field_page: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

const useAirportsPageHeading = (
  options?: UseQueryOptions<PageHeading[], DefaultError, PageHeading[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PageHeading[], DefaultError> => {
  return useQuery<PageHeading[], DefaultError, PageHeading[], QueryKey>(
    {
      queryKey: ["airportsPageHeading"],
      enabled: false,
      queryFn: async (): Promise<PageHeading[]> => {
        const response = await corporateCMSApi.get<PageHeading[]>(
          `/api/page-heading/all-fields?pageName=contact-us/airports`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useCorporatePageHeading = (
  options?: UseQueryOptions<PageHeading[], DefaultError, PageHeading[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PageHeading[], DefaultError> => {
  return useQuery<PageHeading[], DefaultError, PageHeading[], QueryKey>(
    {
      queryKey: ["corporatePageHeading"],
      enabled: false,
      queryFn: async (): Promise<PageHeading[]> => {
        const response = await corporateCMSApi.get<PageHeading[]>(
          `/api/page-heading/all-fields?pageName=contact-us/corporate`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useCorporatePageContent = (
  options?: UseQueryOptions<Corporate[], DefaultError, Corporate[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Corporate[], DefaultError> => {
  return useQuery<Corporate[], DefaultError, Corporate[], QueryKey>(
    {
      queryKey: ["corporatePageContent"],
      enabled: false,
      queryFn: async (): Promise<Corporate[]> => {
        const response = await corporateCMSApi.get<Corporate[]>(
          `/api/page-content/all-fields?pageName=contact-us/corporate`
        );
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAirportsPageHeading, useCorporatePageContent, useCorporatePageHeading };
